import axios from 'axios';
import router from '@/router/index.js'
import { useAuthStore } from '@/stores/auth.js'
import { notify } from '@/components/generic/notification/notification.js'

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Content-Type'] = 'application/json';
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.withCredentials = true;
window.axios.defaults.withXSRFToken = true;

axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  console.error(error)
  const response = error.response
  const publicMessage = response?.data?.error === true && response.data.message

  if(!response) {
    return Promise.reject(error)
  }

  if(publicMessage && ![401, 419, 423].includes(response.status)) {
    notify(response.data.message, 'danger')
    error.publicMessageNotified = true
  }

  if (response.status === 401 || response.status === 419) {
    if (response.data.message === 'CSRF token mismatch.') return Promise.reject(error)
    if (response.data.message === 'Unauthenticated.') return Promise.reject(error)
    useAuthStore().logout()
      .catch((error) => { console.error(error) })
    router.push({ name: 'Login' })
  } else if (response.status === 403 && !publicMessage) {
    notify(response.data.message, 'danger')
  } else if (response.status === 423) {
    router.push({ name: 'ConfirmPassword' })
  }
  else if (response.status === 500 && !publicMessage) {
    if(response.data && response.data.message) {
      notify(response.data.message, 'danger')
    }
  }
  return Promise.reject(error);
});
